export interface MempoolTransactionStatusDto {
  confirmed: boolean;
  blockHeight?: number;
  blockHash?: string;
  blockTime?: number;
}

export interface MempoolPrevoutDto {
  scriptpubkey: string;
  scriptpubkeyAsm: string;
  scriptpubkeyType: string;
  scriptpubkeyAddress?: string;
  value: number;
}

export interface MempoolVinDto {
  txid: string;
  vout: number;
  prevout: MempoolPrevoutDto | null;
  scriptsig: string;
  scriptsigAsm: string;
  witness?: string[];
  isCoinbase: boolean;
  sequence: number;
}

export interface MempoolVoutDto {
  scriptpubkey: string;
  scriptpubkeyAsm: string;
  scriptpubkeyType: string;
  scriptpubkeyAddress?: string;
  value: number;
}

export interface MempoolAddressTransactionDto {
  txid: string;
  version: number;
  locktime: number;
  vin: MempoolVinDto[];
  vout: MempoolVoutDto[];
  size: number;
  weight: number;
  fee: number;
  status: MempoolTransactionStatusDto;
}

interface MempoolTransactionStatusApiResponse {
  confirmed: boolean;
  block_height?: number;
  block_hash?: string;
  block_time?: number;
}

interface MempoolPrevoutApiResponse {
  scriptpubkey: string;
  scriptpubkey_asm: string;
  scriptpubkey_type: string;
  scriptpubkey_address?: string;
  value: number;
}

interface MempoolVinApiResponse {
  txid: string;
  vout: number;
  prevout: MempoolPrevoutApiResponse | null;
  scriptsig: string;
  scriptsig_asm: string;
  witness?: string[];
  is_coinbase: boolean;
  sequence: number;
}

interface MempoolVoutApiResponse {
  scriptpubkey: string;
  scriptpubkey_asm: string;
  scriptpubkey_type: string;
  scriptpubkey_address?: string;
  value: number;
}

interface MempoolAddressTransactionApiResponse {
  txid: string;
  version: number;
  locktime: number;
  vin: MempoolVinApiResponse[];
  vout: MempoolVoutApiResponse[];
  size: number;
  weight: number;
  fee: number;
  status: MempoolTransactionStatusApiResponse;
}

function mapStatus(
  status: MempoolTransactionStatusApiResponse,
): MempoolTransactionStatusDto {
  return {
    confirmed: status.confirmed,
    blockHeight: status.block_height,
    blockHash: status.block_hash,
    blockTime: status.block_time,
  };
}

function mapPrevout(
  prevout: MempoolPrevoutApiResponse | null,
): MempoolPrevoutDto | null {
  if (!prevout) {
    return null;
  }
  return {
    scriptpubkey: prevout.scriptpubkey,
    scriptpubkeyAsm: prevout.scriptpubkey_asm,
    scriptpubkeyType: prevout.scriptpubkey_type,
    scriptpubkeyAddress: prevout.scriptpubkey_address,
    value: prevout.value,
  };
}

function mapVin(vin: MempoolVinApiResponse): MempoolVinDto {
  return {
    txid: vin.txid,
    vout: vin.vout,
    prevout: mapPrevout(vin.prevout),
    scriptsig: vin.scriptsig,
    scriptsigAsm: vin.scriptsig_asm,
    witness: vin.witness,
    isCoinbase: vin.is_coinbase,
    sequence: vin.sequence,
  };
}

function mapVout(vout: MempoolVoutApiResponse): MempoolVoutDto {
  return {
    scriptpubkey: vout.scriptpubkey,
    scriptpubkeyAsm: vout.scriptpubkey_asm,
    scriptpubkeyType: vout.scriptpubkey_type,
    scriptpubkeyAddress: vout.scriptpubkey_address,
    value: vout.value,
  };
}

export function mempoolAddressTransactionFromApiResponse(
  response: MempoolAddressTransactionApiResponse,
): MempoolAddressTransactionDto {
  return {
    txid: response.txid,
    version: response.version,
    locktime: response.locktime,
    vin: response.vin.map(mapVin),
    vout: response.vout.map(mapVout),
    size: response.size,
    weight: response.weight,
    fee: response.fee,
    status: mapStatus(response.status),
  };
}
